import {
	ContainsDialogsContext,
	ContainsDialogsContextData
} from "client/Contexts/ContainsDialogsContext";
import { RegisterElement, useContainsElementStack } from "client/Hooks";
import {
	PropsWithChildren,
	ReactElement,
	useCallback,
	useContext,
	useMemo
} from "react";

export type ContainsDialogsWrapperProps = {
	onDoesContainDialogsChange(value: boolean): void;
};

export const ContainsDialogsWrapper = (props: PropsWithChildren<ContainsDialogsWrapperProps>): ReactElement => {
	const {
		onDoesContainDialogsChange,
		children
	} = props;

	const {
		registerDialog: parentRegisterDialog
	} = useContext(ContainsDialogsContext);

	const registerDialog: RegisterElement = useContainsElementStack(
		onDoesContainDialogsChange
	);

	const registerDialogHandler = useCallback<RegisterElement>(
		(): (() => void) => {
			const cleanParent: (() => void) | undefined = parentRegisterDialog?.();
			const cleanLocal: () => void = registerDialog();

			return (): void => {
				cleanLocal();
				cleanParent?.();
			};
		},
		[
			parentRegisterDialog,
			registerDialog
		]
	);

	const contextData = useMemo(
		(): ContainsDialogsContextData => {
			return {
				registerDialog: registerDialogHandler
			};
		},
		[registerDialogHandler]
	);

	return (
		<ContainsDialogsContext.Provider value={contextData}>
			{children}
		</ContainsDialogsContext.Provider>
	);
};
ContainsDialogsWrapper.displayName = "ContainsDialogsWrapper";